import React from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import Home from './Home';
import Shell from './components/Shell';
import { Routes, BrowserRouter as Router, Route } from 'react-router-dom';
import { ScrollingProvider } from 'react-scroll-section';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ScrollingProvider offset={0}>
        <Router>
          <Routes>
            <Route path="/" element={<Shell />}>
              <Route index element={<Home />} />
            </Route>
          </Routes>
        </Router>
      </ScrollingProvider>
    </ThemeProvider>
  );
}

export default App;
